import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as S from './styled';
import Button from '../../Button';
import { ERROR_PAGE_BUTTON_MESSAGE, PAGE_ERROR_MESSAGE } from '../../../constants/service/common/pageConstants';
import { AxiosError } from 'axios';
import { ErrorResponseType, extractErrorMessage } from '../../../lib/utils/checkErrorResponse';

interface IErrorSectionProps {
  error: AxiosError | Error | unknown;
}

const GlobalError = ({ error }: IErrorSectionProps): JSX.Element => {
  const navigate = useNavigate();

  const statusCode = error instanceof AxiosError ? error.response?.status || 400 : 400;
  const errorMessage = extractErrorMessage(error as ErrorResponseType);

  const isNotAuthorized = statusCode === 401;
  const isNotFound = statusCode === 404;

  const onClickHandler = () => {
    if (isNotAuthorized) {
      localStorage.clear();
      window.location.reload();
    } else {
      navigate(-1);
    }
  };

  const subTitleFirst = isNotFound
    ? PAGE_ERROR_MESSAGE.PAGE_NOT_FOUND_MESSAGE
    : PAGE_ERROR_MESSAGE.UNABLE_TO_PROCESS_MESSAGE;

  return (
    <S.Container>
      <S.ErrorMessageWrap>
        <S.Status>{statusCode} Error</S.Status>
        <S.Message>{errorMessage}</S.Message>
      </S.ErrorMessageWrap>
      <S.ContentWrap>
        <p>{subTitleFirst}</p>
      </S.ContentWrap>
      <Button
        color="primary"
        text={isNotAuthorized ? ERROR_PAGE_BUTTON_MESSAGE.REDIRECT_LOGIN : ERROR_PAGE_BUTTON_MESSAGE.REDIRECT_LOGIN}
        onClick={onClickHandler}
      />
    </S.Container>
  );
};

export default GlobalError;
